import React, { useState } from "react";
import styled from "styled-components";

const TextContainer = styled.div`
  font-family: ${({ $fontFamily }) => $fontFamily || '"moret", sans-serif'};
  color: ${({ $colorin }) => $colorin || "white"};
  display: inline-flex;
  flex-wrap: wrap;
  font-size: ${({ $fontSize }) => $fontSize || "inherit"}; // Use 'inherit' as default

  @media (max-width: 768px) {
    font-size: ${({ $mobileFontSize }) => $mobileFontSize || "inherit"};
  }
`;

const Character = styled.span`
  display: inline-block;
  transition: transform 0.5s ease, font-variation-settings 0.5s ease;
  font-variation-settings: "wght" ${({ $weight }) => $weight};
  transform: scale(${({ $scale }) => $scale || 1});
  will-change: transform, font-variation-settings; // Optimize for smooth animations

  &:hover {
    color: ${({ $colorin }) => $colorin || "white"};
  }
`;

const TextShift = ({
  text,
  maxWeight = 900,
  minWeight = 100,
  fontSize,
  mobileFontSize,
  adjacentWeightChange = 200,
  fontFamily,
  colorin,
}) => {
  const [hoverIndex, setHoverIndex] = useState(null);

  const calculateWeight = (index) => {
    if (hoverIndex === null) return minWeight;
    const distance = Math.abs(index - hoverIndex);
    const weightDecrease = Math.min(
      distance * adjacentWeightChange,
      maxWeight - minWeight
    );
    return maxWeight - weightDecrease;
  };

  const calculateScale = (index) => {
    if (hoverIndex === null) return 1; // Default scale
    const distance = Math.abs(index - hoverIndex);
    const scaleDecrease = Math.min(distance * 0.1, 0.5); // Adjust scale factor
    return 1.2 - scaleDecrease; // Scale down based on distance
  };

  return (
    <TextContainer
      $fontSize={fontSize}
      $mobileFontSize={mobileFontSize}
      $fontFamily={fontFamily}
      $colorin={colorin}
    >
      {text.split("").map((char, index) => {
        const isSpace = char === " ";
        const displayChar = isSpace ? "\u00A0" : char; // Use non-breaking space for spaces

        return (
          <Character
            key={index}
            $weight={calculateWeight(index)}
            $scale={calculateScale(index)}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            $colorin={colorin}
            style={{
              transitionDelay: `${Math.abs(index - (hoverIndex || 0)) * 0.01}s`, // Smoother staggered delay
            }}
          >
            {displayChar}
          </Character>
        );
      })}
    </TextContainer>
  );
};

export default TextShift;